import * as React                   from 'react';
import {connect}                    from "react-redux";
import Utils                        from "../../../../Utils";
import * as toastr                  from "toastr";
import LoadingModal                 from "../../modals/LoadinModal";
import {createColumnsOfDataView}    from "../../../../actions/boCoreActions";
import {DataTypesEnum}              from "../../enums/dataTypesEnum";
import GridSelect                   from './components/GridSelect'
import _                            from "lodash";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"

const AgGridReact = require('ag-grid-react').AgGridReact;

interface State {
    columnDefs: any;
    rowData: any;
    gridApi: any;
    columnApi: any;
    loading: boolean;
}

interface Props {
    businessObjectsWrapper: any
    columnsOfDataViewAreBeingCRUD: any
    createColumnsOfDataViewUpdateFlag: any
    currentDataView: any
    createColumnsOfDataView: any
    currentSlide: any
    columnsAgGridRef: any
}


class DataViewColumnsAgGrid extends React.Component<Props, State> {
    private rowData = [];
    private rowDataCopy = [];
    private continueWithoutSaving = false;

    constructor(props: Props) {
        super(props);
        this.state = {
            columnDefs: [],
            rowData: [],
            gridApi: null,
            columnApi: null,
            loading: false
        };
        props.columnsAgGridRef.current = this;
    }

    componentDidMount(): void {
        this.buildGrid();
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (this.props.currentDataView.id !== prevProps.currentDataView.id) {
            this.buildGrid();
        }
        if (this.props.currentSlide !== prevProps.currentSlide && this.props.currentSlide === 'second') {
            document.addEventListener('keydown', this.shortcuts);
            this.continueWithoutSaving = false;
        }
        if (this.props.currentSlide !== prevProps.currentSlide && this.props.currentSlide === 'first') {
            this.resetFiltersAndFocus();
            document.removeEventListener('keydown', this.shortcuts);
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.shortcuts);
    }

    resetFiltersAndFocus = () => {
        this.state.gridApi.clearFocusedCell();
        this.state.gridApi.deselectAll();
        this.state.gridApi.setFilterModel(null);
        Utils.$('#dataViewConfigurationGrid-search').focus();
    };

    shortcuts = (e) => {
        if(e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#data_view_form_delete_btn').click();
        }
        if(e.shiftKey && e.keyCode === 37) {
            Utils.$('#dataViewConfigurationSlide').click();
        }
        if(e.ctrlKey && e.altKey && e.keyCode === 78) {
            Utils.$('#data_view_form_new_btn').click();
        }
        if(e.ctrlKey && e.altKey && e.keyCode === 83) {
            Utils.$('#data_view_form_save_btn').click();
        }
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.d-view-grid-2')[0].focus();
            this.state.gridApi.clearFocusedCell();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("d-view-grid-2")) {
                if (Number.parseInt(id) === 1 || Utils.$('.d-view-grid-2').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.d-view-grid-2')[index].focus();
                }
            }
        }
    };

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.columnApi.getAllDisplayedColumns()[0];
            this.state.gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.gridApi.setFocusedCell(0, currentCol);
        }
    };

    prepareGridData = () => {
        this.rowData = [];
        let rowData;
        if (this.props.currentDataView) {
            if (this.props.currentDataView.columns.length > 0) {
                rowData = this.props.currentDataView.columns.map(item => {
                    return {
                        columnOrder: item.columnOrder,
                        isNew: false,
                        rowObj: {
                            column: item.value.name ? item.value.name : item.value._name,
                            type: item.type,
                            id: item.id,
                            attr: item.value
                        }
                    }
                });
                return rowData
            } else {
                return [];
            }
        }
    };

    populateSelectValues = () => {
        if (this.props.currentDataView &&
            this.props.currentDataView.businessObjectClass &&
            this.props.currentDataView.businessObjectClass.relationships) {
            const businessObject = this.props.businessObjectsWrapper.getBusinessObject(this.props.currentDataView.businessObjectClass.id);

            const relationshipMap = this.props.currentDataView.businessObjectClass.relationships;
            const relationshipList = Array.from(relationshipMap.values());
            const attributes = businessObject.getAttributes(DataTypesEnum.ARRAY);

            return {
                attr: attributes,
                relationshipList: relationshipList
            }
        }
        return null
    };

    hasChanges = (): boolean => {
        if (!this.continueWithoutSaving) {
            this.updateThisRowData();
        }
        return !(_.isEqual(this.rowData, this.rowDataCopy));
    }

    changesPrompt = () => {
        Utils.$.confirm({
            title: 'Confirm?',
            keyboardEnabled: true,
            escapeKey: 'cancel',
            backgroundDismiss: false,
            content: 'There are unsaved changes. Are you sure you want to continue?',
            type: 'red',
            theme: 'dark',
            typeAnimated: false,
            buttons: {
                ok: {
                    text: "Yes!",
                    btnClass: 'btn-danger',
                    keys: ['enter'],
                    action: () => {
                        this.continueWithoutSaving = true;
                        this.rowData = this.rowDataCopy;
                        this.state.gridApi.setRowData(this.rowDataCopy);
                        Utils.$('#dataViewConfigurationSlide').click();
                    }
                },
                cancel: () => {
                    this.continueWithoutSaving = false;
                }
            }
        });
    }

    buildGrid = () => {
        const rowData = this.prepareGridData();
        this.rowDataCopy = _.cloneDeep(rowData);
        const selectOptions = this.populateSelectValues();

        const columnDefs = [
            // {
            //     rowDrag: true,
            //     width: 40,
            //     // suppressMenu: true,
            //     suppressSizeToFit: true,
            // },
            {
                colId: 'checkbox',
                width: 40,
                checkboxSelection: true,
                headerCheckboxSelection: true,
                suppressSizeToFit: true,
                floatingFilter: false,
                filter: false
            },
            {
                id: "type",
                headerName: "Type",
                field: "rowObj.type",
                headerTooltip: "Type",
                width: 250,
                type: 'text',
                rowDrag: true,
                suppressSizeToFit: true,
                // cellRenderer: function (params) {
                //     return `<span>${params.value.type}</span>`
                // },
                filterParams: {
                    valueGetter: params => {
                        return params.data.rowObj.type
                    }
                }

            },
            {
                field: 'rowObj',
                headerName: "Column",
                tooltipField: 'column',
                headerTooltip: "Column",
                minWidth: 200,
                type: 'value list',
                editable: true,
                cellEditor: 'agSelect',
                options: selectOptions ? selectOptions : [],
                cellRenderer: function (params) {
                    return `<span>${params.value.column}</span>`
                },
                filterParams: {
                    valueGetter: params => {
                        return params.data.rowObj.column
                    }
                }
            },
        ];
        this.setState({rowData, columnDefs}, () => this.updateColumnSize());
    };

    updateColumnSize = () => {
        if (this.state.gridApi) {
            this.state.gridApi.sizeColumnsToFit();
        }
        Utils.$("#dataViewFormGrid").find('.ag-floating-filter-input').each(function( index ) {
            Utils.$(this).attr('id', 'd-view2-filter-' + index);
            Utils.$(this).addClass('d-view-grid-2');
            Utils.$(this).attr('index', (index + 1));
        });
    };

    onGridReady = (params) => {
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        }, () =>  params.api.sizeColumnsToFit());
        params.api.forEachNode(node => this.rowData.push(node.data));
    };

    onSave = () => {
        const {currentDataView} = this.props;
        this.updateThisRowData();
        this.state.gridApi.stopEditing();
        if (currentDataView.viewName === "full" && this.rowData[0].rowObj.column !== 'Name') {
            // Actually on the grid it will be shown as second column right after the ID column
            toastr.warning("Name column must always be at first position in full view");
        } else {
            this.setState({loading: true});
            let dto = [];
            for (let i = 0; i < this.rowData.length; i++) {
                const column = currentDataView.getColumn(this.rowData[i].rowObj.id);
                if (column) {
                    column['columnOrder'] = i + 2;
                    dto.push({
                        columnOrder: i + 2,
                        columnType: this.rowData[i].rowObj.type,
                        valueId: this.rowData[i].rowObj.id
                    });
                } else {
                    currentDataView.createColumn(this.rowData[i]);
                    const column = currentDataView.getColumn(this.rowData[i].rowObj.id);
                    if (column) {
                        column['columnOrder'] = i + 2;
                        dto.push({
                            columnOrder: i + 2,
                            columnType: this.rowData[i].rowObj.type,
                            valueId: this.rowData[i].rowObj.id
                        });
                    }
                }
            }
            this.props.createColumnsOfDataView(currentDataView.id, dto, () => {
                this.setState({loading: false});
                currentDataView.sortColumns();
                this.removeIsNewProp();
                this.rowDataCopy = _.cloneDeep(this.rowData);
            }, () => {
                //Error
                this.setState({loading: false});
            });
        }
    };

    removeIsNewProp = () => {
        this.state.gridApi.forEachNode(node => {
            if (node.data.isNew) {
                delete node.data.isNew
            }
        });
        this.updateThisRowData();
    };

    deleteRow = () => {
        const {currentDataView} = this.props;
        const selectedData = this.state.gridApi.getSelectedRows();
        if (selectedData.length > 0) {
            this.state.gridApi.stopEditing();
            const newRows = selectedData.filter( row => row.isNew === true);
            const oldRows = selectedData.filter( row => !row.isNew);
            this.removeSelectedRows(newRows);
            this.updateThisRowData();

            if (oldRows.length > 0) {
                let confirm = Utils.$.confirm({
                    title: 'Confirm?',
                    keyboardEnabled: true,
                    escapeKey: 'cancel',
                    backgroundDismiss: false,
                    content: `You are about to delete ${oldRows.length} ${oldRows.length > 1 ? 'columns' : 'column'}.`,
                    type: 'red',
                    theme: 'dark',
                    typeAnimated: false,
                    buttons: {
                        ok: {
                            text: "Yes!",
                            btnClass: 'btn-danger',
                            keys: ['enter'],
                            action: () => {
                                confirm = null;
                                this.setState({loading: true});

                                selectedData.forEach(item => this.deleteRowDataColumn(item.rowObj.id));
                                let dto = [];
                                for (let i = 0; i < this.rowData.length; i++) {
                                    const column = currentDataView.getColumn(this.rowData[i].rowObj.id);
                                    column['columnOrder'] = i + 2;
                                    dto.push({
                                        columnOrder: i + 2,
                                        columnType: this.rowData[i].rowObj.type,
                                        valueId: this.rowData[i].rowObj.id
                                    });
                                }

                                this.props.createColumnsOfDataView(currentDataView.id, dto, () => {
                                    this.removeSelectedRows(selectedData);
                                    selectedData.forEach(item => currentDataView.deleteColumn(item.rowObj.id));
                                    this.updateThisRowData();
                                    this.rowDataCopy = _.cloneDeep(this.rowData);
                                    this.setState({loading: false});
                                }, () => {
                                    // Error
                                    this.updateThisRowData();
                                    this.setState({loading: false});
                                });
                            }
                        },
                        cancel: function () {
                            confirm = null;
                        }
                    }
                });
            }
        } else {
            toastr.warning('Please select a row you want to delete.');
        }
    };

    removeSelectedRows = (selectedData) => {
        this.state.gridApi.updateRowData({ remove: selectedData });
        this.state.gridApi.refreshCells({ force: true });
    };

    deleteRowDataColumn = (columnId) => {
        const index = this.rowData.findIndex(item => item.rowObj.id === columnId);
        if (index !== -1){
            this.rowData.splice(index,1);
        }
    };

    /**
     * Summary:
     * This method gets all the data from the grid.
     */
    updateThisRowData = () => {
        this.rowData = [];
        this.state.gridApi.forEachNode(node => this.rowData.push(node.data));
    };

    addNew = () => {
        this.updateThisRowData();
        this.state.gridApi.deselectAll();
        this.state.gridApi.setFilterModel(null);
        this.state.gridApi.updateRowData({
            add: [{
                columnOrder: this.rowData.length + 1,
                isNew: true,
                rowObj: {
                    column: '',
                    type: '',
                    id: 0,
                    attr: {}
                }
            }
            ], addIndex: this.rowData.length
        });

        try {
            this.state.gridApi.startEditingCell({
                rowIndex: this.rowData.length,
                colKey: this.state.columnApi.getAllColumns()[2].colId
            });
        } catch (e) {
            console.log('Cell Edit Error: Maybe the current data view has all columns')
        }
    };

    cellEditorHandler = (params) => {
        if (!params.data.isNew) {
            params.api.stopEditing();
        }
    };

    onFilterChanged = (params) => {
        params.api.deselectAllFiltered();
        params.api.deselectAll();
        let filteredNodes = [];
        params.api.forEachNodeAfterFilter((node) => {
            filteredNodes.push(node);
        });
    };

    render() {
        const {currentDataView} = this.props;
        return (
            <React.Fragment>
                <LoadingModal open={this.state.loading}/>
                <header className={'bo-core-header dv-form-header background-gradient'} >
                <div id={'bo-type'}>
                    <span style={{color: '#dedcda', fontWeight: 'bold', marginLeft: '10px', fontSize: '20px'}}>
                        BO TYPE: {currentDataView.businessObjectClass.name}
                    </span>
                </div>
                    <div style={{display: 'flex'}}>
                        <button style={{marginRight: 5}} id="data_view_form_new_btn"
                                onClick={this.addNew} title={'CTRL + ALT + N'}
                                className="btn btn-success">
                            <i className="fas fa-plus"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>N</strong>ew
                        </button>
                        <button id="data_view_form_save_btn"
                                onClick={this.onSave}
                                title={'CTRL + ALT + S'}
                                className="btn btn-primary">
                            <i className="fas fa-save"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>S</strong>ave
                        </button>
                        <button style={{marginRight: '5px', marginLeft: '5px'}}
                                id="data_view_form_delete_btn"
                                className="btn btn-danger"
                                title={'CTRL + ALT + D'}
                                onClick={this.deleteRow}>
                            <i className="fas fa-trash-alt"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>D</strong>elete
                        </button>
                        {/*<div id="dropzone" className="recycle-bin" style={{marginRight: '5px'}}>*/}
                        {/*    <i style={{float: "left", paddingTop: 4}} className="fa fa-trash"/>*/}
                        {/*    <span style={{float: "left", paddingLeft: 3, paddingTop: 7}}>Recycle Bin</span>*/}
                        {/*</div>*/}
                    </div>
                </header>
                <div id="grid_container" style={{
                    borderBottom: "2px solid black",
                    height: "calc(100% - 39px)",
                    margin: 0,
                    padding: 0,
                    width: "100%"
                }}>
                    <div className="ag-theme-balham-dark ag-grids"
                         style={{backgroundColor: "#353535", width: "100%", height: "100%", paddingBottom: '10px'}}
                         id="DataViewObjectsGrid">
                        <AgGridReact
                            onGridReady         = {this.onGridReady}
                            onFirstDataRendered = {this.onGridReady}
                            onFilterChanged     = {this.onFilterChanged}
                            columnDefs          = {this.state.columnDefs}
                            rowData             = {this.state.rowData}
                            rowDragManaged      = {true}
                            animateRows         = {true}
                            defaultColDef={{
                                minWidth: 150,
                                flex: 1,
                                filter: "agTextColumnFilter",
                                floatingFilterComponentParams: {suppressFilterButton: true},
                            }}
                            gridOptions={{
                                floatingFilter: true,
                                resizable: true,
                                suppressDragLeaveHidesColumns: true,
                                rowSelection: "multiple",
                                components: {
                                    agSelect: GridSelect()
                                },
                                singleClickEdit: true,
                                onCellEditingStarted: this.cellEditorHandler
                            }}
                        >
                        </AgGridReact>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        businessObjectsWrapper: state.boCore.businessObjectsWrapper,
        columnsOfDataViewAreBeingCRUD: state.boCore.columnsOfDataViewAreBeingCRUD,
        createColumnsOfDataViewUpdateFlag: state.boCore.createColumnsOfDataViewUpdateFlag,
        currentDataView: ownProps.currentDataView,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createColumnsOfDataView: (id, dto, callBack, errCallBack) => {
            dispatch(createColumnsOfDataView(id, dto, callBack, errCallBack));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DataViewColumnsAgGrid);




// WEBPACK FOOTER //
// ./app/components/bo-core/grids/DataViewColumnsAgGrid/DataViewColumnsAgGrid.tsx